import { Injectable } from "@angular/core";
import { Api } from "../base";

import { Observable } from "rxjs";

/**
 * 未ログイン(匿名)状態でweb_track_token付きリンクからアプリを起動したことをサーバへ記録するAPI。
 * 非認証エンドポイント(anonymous_device_trackings)を叩く。
 * デバイス識別子はbodyでは送らず、Apiクラスが常時付与するX-Ckuru-Uuidヘッダをサーバ側で読む。
 */
@Injectable({
  providedIn: "root",
})
export class AnonymousDeviceTrackingProvider {
  url = "anonymous_device_trackings";

  constructor(private api: Api) {}

  create(webTrackToken: string): Observable<SuccessJSON> {
    return this.api.post(this.url, {
      web_track_token: webTrackToken,
    });
  }
}
